// themeUtils.js
import { createContext, useContext } from 'react'

// Create the context
export const ThemeContext = createContext()

// Custom hook to access the theme context
export const useTheme = () => useContext(ThemeContext)

// Function to toggle between light and dark modes
export const toggleTheme = (theme, setTheme) => {
  setTheme(prevTheme => (prevTheme === 'light' ? 'dark' : 'light'))
}
